export const isMobile = () =>
  typeof window.matchMedia === "function"
    ? window.matchMedia("(max-width: 599px)").matches
    : false;
